import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LabsSection = ({ items, hideHeader = false }) => {
  const navigate = useNavigate();

  const openDetail = (id) => {
    if (!id) return;
    navigate(`/labs-detail?id=${id}`);
  };

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      {!hideHeader ? (
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">꿈현 Labs에게 요구합니다!</h2>
          <Icon name="MessageSquareText" size={20} color="var(--color-primary)" />
        </div>
      ) : null}

      <div className="space-y-2">
        {(!items || items.length === 0) && (
          <div className="p-4 bg-muted/30 rounded-md border border-border/50">
            <p className="text-sm text-muted-foreground caption">아직 글이 없습니다.</p>
          </div>
        )}

        {(items || []).map((n) => (
          <div
            key={n.id}
            className="p-3 md:p-4 bg-muted/50 rounded-md border border-border/50 cursor-pointer hover:bg-muted transition-gaming"
            onClick={() => openDetail(n.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') openDetail(n.id);
            }}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-sm md:text-base font-medium text-foreground truncate">{n.title}</div>
                <div className="text-xs text-muted-foreground caption mt-1">{n.date} · {n.authorName || '익명'}</div>
              </div>
              {n.hasReply ? (
                <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-primary/15 text-primary border border-primary/20 flex-shrink-0">
                  답변
                </span>
              ) : (
                <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-muted text-muted-foreground border border-border flex-shrink-0">
                  대기
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LabsSection;
